import {
    CREATEPURCHESEMEDICINE,
    CREATEPURCHESEMEDICINEBILL,
    DELETEPURCHESEMEDICINE,
    DELETEPURCHESEMEDICINEBILL,
    GETPURCHESEMEDICINE,
    GETPURCHESEMEDICINEAVIQTY,
    GETPURCHESEMEDICINEBILL,
    UPDATEPURCHESEMEDICINE,
    UPDATEAVAILQTY,
    UPDATEPURCHESEMEDICINEBILL,
    RESERVE_STOCK_SUCCESS,
    RESERVE_STOCK_FAILURE,
    RESTORE_RESERVED_STOCK_SUCCESS,
    RESTORE_RESERVED_STOCK_FAILURE,
    DELETEPURCHESEMEDICINESHOW,
    UPDATEPURCHESEMEDICINESHOW,
    GETPURCHESEMEDICINESHOW,
    CREATEPURCHESEMEDICINESHOW,
    CREATEPURCHESEMEDICINEBILLTRANSACTION,
    GETPURCHESEMEDICINEBILLTRANSACTION,
    UPDATEPURCHESEMEDICINEBILLTRANSACTION,
    DELETEPURCHESEMEDICINEBILLTRANSACTION
} from '../actions/types';

const initialState = {
    reserveStockStatus: null,
    restoreReservedStockStatus: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEPURCHESEMEDICINE:
            return {
                ...state,
                purchesemedicineSaveStatus: action.payload.success,
            }
        case GETPURCHESEMEDICINE:
            return {
                ...state,
                purchasemedicineList: action.payload.data,
            }
        case GETPURCHESEMEDICINEAVIQTY:
            return {
                ...state,
                purchasemedicineavlqtyList: action.payload.data,
            }
        case UPDATEPURCHESEMEDICINE:
            return {
                ...state,
                purchesemedicineUpdateStatus: action.payload.success,
            }
        case UPDATEAVAILQTY:
            return {
                ...state,
                purchesemedicineUpdateStatus: action.payload.success,
            }
        case DELETEPURCHESEMEDICINE:
            return {
                ...state,
                purchesemedicineDeleteStatus: action.payload.success,
            }

        case CREATEPURCHESEMEDICINEBILL:
            return {
                ...state,
                purchesemedicinebillSaveStatus: action.payload.success,
            }
        case GETPURCHESEMEDICINEBILL:
            return {
                ...state,
                purchesemedicinebillList: action.payload.data,
            }
        case UPDATEPURCHESEMEDICINEBILL:
            return {
                ...state,
                purchesemedicinebillUpdateStatus: action.payload.success,
            }

        case DELETEPURCHESEMEDICINEBILL:
            return {
                ...state,
                purchesemedicinebillDeleteStatus: action.payload.success,
            }

        // Handle new actions
        case RESERVE_STOCK_SUCCESS:
            return {
                ...state,
                reserveStockStatus: action.payload, // Store the response or success message
            };
        case RESERVE_STOCK_FAILURE:
            return {
                ...state,
                reserveStockStatus: action.payload, // Store failure message or error details
            };

        case RESTORE_RESERVED_STOCK_SUCCESS:
            return {
                ...state,
                restoreReservedStockStatus: action.payload, // Store the success response
            };
        case RESTORE_RESERVED_STOCK_FAILURE:
            return {
                ...state,
                restoreReservedStockStatus: action.payload, // Store failure message or error details
            };
            case CREATEPURCHESEMEDICINESHOW:
            return {
                ...state,
                purchesemedicineshowSaveStatus: action.payload.success,
            }
        case GETPURCHESEMEDICINESHOW:
            return {
                ...state,
                purchasemedicineshowList: action.payload.data,
            }
            case UPDATEPURCHESEMEDICINESHOW:
            return {
                ...state,
                purchesemedicineshowUpdateStatus: action.payload.success,
            }
        case DELETEPURCHESEMEDICINESHOW:
            return {
                ...state,
                purchesemedicineshowDeleteStatus: action.payload.success,
            }
            case CREATEPURCHESEMEDICINEBILLTRANSACTION:
            return {
                ...state,
                purchesemedicinebilltransactionSaveStatus: action.payload.success,
            }
        case GETPURCHESEMEDICINEBILLTRANSACTION:
            return {
                ...state,
                purchesemedicinebilltransactionList: action.payload.data,
            }
        case UPDATEPURCHESEMEDICINEBILLTRANSACTION:
            return {
                ...state,
                purchesemedicinebilltransactionUpdateStatus: action.payload.success,
            }

        case DELETEPURCHESEMEDICINEBILLTRANSACTION:
            return {
                ...state,
                purchesemedicinebilltransactionDeleteStatus: action.payload.success,
            }
        default:
            return state
    }

}